import { call, put, select, takeLatest } from 'redux-saga/effects'
import { BillingConstants } from '../../billing/store/billing.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { setPaymentInformation as setPaymentInformationAction } from '../store/paymentInformation.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'

export function* setPaymentInformation(pcrDoc: IPcr) {
  const paymentInformation = pcrDoc.billing?.paymentInformation
  if (paymentInformation && Object.keys(paymentInformation).length !== 0) {
    yield put(setPaymentInformationAction(paymentInformation))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(setPaymentInformation, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in setPaymentInformation.saga.ts: ${e}`))
  }
}

export function* setPaymentInformationSaga() {
  yield takeLatest([BillingConstants.REFRESH_BILLING_DATA], performWithMutexHOG, preloadPCR)
}
